var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('MainQuestion',{staticClass:"main_question"}),_c('Side',{staticClass:"side_items"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }